module.exports = __webpack_public_path__ + "assets/img/sjjk.d8c278d4.png";